import { render, staticRenderFns } from "./calcTable.vue?vue&type=template&id=37f5c558&scoped=true"
import script from "./calcTable.vue?vue&type=script&lang=js"
export * from "./calcTable.vue?vue&type=script&lang=js"
import style0 from "./calcTable.vue?vue&type=style&index=0&id=37f5c558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f5c558",
  null
  
)

export default component.exports